import { useState } from "react";
import { Flex } from "antd";
import { StringParam } from "use-query-params";

import { useProduct } from "hooks/useProduct";
import { useQueryParamsWithProducts } from "functions/queryParamFuncs";
import ItemInfoCard from "components/ItemDetails/ItemInfoCard";
import SearchBar from "components/Common/SearchBar";
import UnitListCard from "components/ItemDetails/UnitListCard";
import useFetch from "hooks/useFetch";

const ItemDetailsPage = () => {
  const { selectedProductIds } = useProduct();
  const [prevProductIds, setPrevProductIds] = useState(selectedProductIds);
  const [queryParams, setQueryParams] = useQueryParamsWithProducts(
    selectedProductIds,
    { item: StringParam }
  );
  const { loading, doFetch: getItemUuid } = useFetch(
    "/items/getItemUuid",
    "GET",
    []
  );
  const [searchBarKey, setSearchBarKey] = useState(1);
  const [searchRefNoValue, setSearchRefNoValue] = useState("");
  const itemUuid = queryParams.item;

  const fetchItemUuid = (refNoValue = "") => {
    getItemUuid({
      products: selectedProductIds,
      ref_no: refNoValue,
      item: itemUuid,
    }).then((response) => {
      if (!!response) {
        setQueryParams({
          products: selectedProductIds,
          item: response.data?.data,
        });
      }
      setSearchRefNoValue(refNoValue);
      setSearchBarKey(searchBarKey + 1);
    });
  };

  if (prevProductIds.toString() !== selectedProductIds.toString()) {
    setPrevProductIds(selectedProductIds);
    if (!!itemUuid || !!searchRefNoValue) {
      fetchItemUuid(searchRefNoValue);
    } else {
      setSearchBarKey(searchBarKey + 1);
    }
  }

  return (
    <>
      <Flex vertical={true} gap="small">
        <SearchBar
          key={searchBarKey}
          defaultValue={searchRefNoValue}
          onSearch={fetchItemUuid}
          loading={loading}
          required={true}
          enableOnChange={true}
        />
        <ItemInfoCard key={"item_info_" + itemUuid} itemUuid={itemUuid} />
        <UnitListCard key={"unit_list_" + itemUuid} itemUuid={itemUuid} />
      </Flex>
    </>
  );
};

export default ItemDetailsPage;
